module.exports = __webpack_public_path__ + "static/media/illusrtrator.9a08fe13.png";